import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { authService } from '../../store/services/ServiceAuth'

const PublicRoute = ({ children, restricted = false }) => {
    const [isLoading, setIsLoading] = useState(true)
    const [isAuthenticated, setIsAuthenticated] = useState(false)

    useEffect(() => {
        async function checkAuth() {
            if (restricted) {
                const isValid = await authService.validateToken()
                setIsLoading(false)
                setIsAuthenticated(!!isValid)
            } else {
                setIsLoading(false)
            }
        }
        
        checkAuth()
    }, [restricted])

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
            </div>
        )
    }

    if (restricted && isAuthenticated) {
        return <Navigate to="/dashboard" replace />
    }

    return children
}

export default PublicRoute